import { render, staticRenderFns } from "./InformacaoPastaNovo.vue?vue&type=template&id=488117fc"
import script from "./InformacaoPastaNovo.vue?vue&type=script&lang=js"
export * from "./InformacaoPastaNovo.vue?vue&type=script&lang=js"
import style0 from "./InformacaoPastaNovo.vue?vue&type=style&index=0&id=488117fc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports